/* eslint-disable react/no-array-index-key */
import React from 'react';
import { Grid, GridItem, Skeleton } from '@chakra-ui/react';

export const ProfileFormLoader = () => (
  <Grid templateColumns="repeat(6, 1fr)" gap={4} mt={16}>
    {[...Array(3)].map((_, i) => (
      <GridItem colSpan={2} key={i}>
        <Skeleton height="49px" />
      </GridItem>
    ))}
    <GridItem colSpan={[3, 3, 2]}>
      <Skeleton height="49px" />
    </GridItem>
    <GridItem colSpan={[3, 3, 2]}>
      <Skeleton height="49px" />
    </GridItem>
    <GridItem colSpan={[0, 0, 2]} display={['none', 'none', 'grid']} />
    <GridItem mt={4} colSpan={6}>
      <Skeleton height="18px" width="80px" />
    </GridItem>
    {[...Array(3)].map((_, i) => (
      <GridItem colSpan={2} key={i}>
        <Skeleton height="49px" />
      </GridItem>
    ))}
    <GridItem mt={4} colSpan={6}>
      <Skeleton height="18px" width="80px" />
    </GridItem>
    {[...Array(6)].map((_, i) => (
      <React.Fragment key={i}>
        <GridItem colSpan={2}>
          <Skeleton height="49px" />
        </GridItem>
        <GridItem colSpan={4} />
      </React.Fragment>
    ))}
  </Grid>
);
